// 다운로드 센터 뷰 모드(신규=/dlcenter, 클래식=/product/category/0) 선택을 브라우저 세션 동안 유지한다.
const DLCENTER_VIEW_KEY = 'DLCENTER_VIEW';

export type DlCenterView = 'new' | 'classic';

export const getDlCenterView = (): DlCenterView | null => {
  try {
    const view = sessionStorage.getItem(DLCENTER_VIEW_KEY);
    return view === 'classic' || view === 'new' ? view : null;
  } catch (e) {
    return null;
  }
};

export const setDlCenterView = (view: DlCenterView) => {
  try {
    sessionStorage.setItem(DLCENTER_VIEW_KEY, view);
  } catch (e) {
    // sessionStorage 사용 불가 시 무시(유지 기능만 비활성).
  }
};
